import React from 'react';

type Props = {
  color?: string;
} & typeof defaultProps;

const defaultProps = {
  color: '#FFFFFF',
};

const ArrowRightIcon = function ArrowRightIcon({ color }: Props) {
  return (

    <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg" className="arrow-right-icon">
      <path d="M9.07787 0.271695C8.89806 0.0518434 8.61185 -0.0455192 8.3386 0.0202161C8.06535 0.0859514 7.852 0.303495 7.78754 0.582113C7.72307 0.86073 7.81855 1.15257 8.03417 1.33591L13.3591 6.77193H0.746714C0.352156 6.79328 0.0429688 7.12571 0.0429688 7.52859C0.0429687 7.93147 0.352156 8.26391 0.746714 8.28525H13.3591L8.02582 13.7149C7.74697 14.0127 7.74697 14.4813 8.02582 14.7791C8.16407 14.9205 8.35184 15 8.54767 15C8.7435 15 8.93127 14.9205 9.06952 14.7791L15.6657 8.05325C15.8076 7.91402 15.8877 7.72191 15.8877 7.52114C15.8877 7.32038 15.8076 7.12826 15.6657 6.98903L9.07787 0.271695Z" fill={color} />
    </svg>
  );
};

ArrowRightIcon.defaultProps = defaultProps;
export default ArrowRightIcon;
